import React from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import { withTheme } from '@mui/styles';
import PropTypes from 'prop-types';

interface HiddenContentChipProps {
  isVisible: boolean;
  label: string;
  handleClick?: () => void;
  atRight?: boolean;
  smallLabel?: boolean;
}

const PREFIX = 'HiddenColumnsChip';

const classes = {
  root: `${PREFIX}-root`,
  chip: `${PREFIX}-chip`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    position: 'absolute',
    width: '100%',
    height: '100%',
    right: 0,
  },

  [`& .${classes.chip}`]: {
    zIndex: 2,
    padding: `${theme.spacing(0.25)}px ${theme.spacing(2)}px`,
    borderRadius: 25,
    position: 'absolute',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  }
}));

const HiddenContentChip = ({ 
  isVisible = false, 
  label, 
  handleClick, 
  atRight, 
  smallLabel = false 
}: HiddenContentChipProps) => {

  const calculateChipXShift = () => (smallLabel ? -69 : -66) - (label.length - 9) * 5;
  const calculateChipWidth = () => 160 + (label.length - 9) * 10;

  if (isVisible) {
    return (
      <Root className={classes.root}>
        <Chip
          style={
            atRight
              ? {
                transform: 'rotate(-90deg)',
                right: calculateChipXShift(),
                width: calculateChipWidth(),
              }
              : {
                transform: 'rotate(-270deg)',
                left: calculateChipXShift(),
                width: calculateChipWidth(),
              }
          }
          icon={<AddIcon />}
          label={label}
          color="primary"
          className={classes.chip}
          size="small"
          onClick={handleClick}
          clickable
        />
      </Root>
    );
  }

  return null;
};


export default withTheme(HiddenContentChip);
